module.exports = __webpack_public_path__ + "media/27.e20dbc81.mp3";